import { NgModule } from '@angular/core';
import { MatButtonModule, MatChipsModule, MatDatepickerModule, MatDialogModule, MatExpansionModule, MatIconModule, MatProgressSpinnerModule, MatSelectModule } from '@angular/material';
import { FlexLoansComponent } from './flex-loans.component';
import { FlexLoansRoutingModule } from './flex-loans.routing.module';
import { LoanTableComponent } from './loan-table/loan-table.component';
import { InvestmentReversalPopUpComponent } from './loan-table/investment-reversal-pop-up/investment-reversal-pop-up.component'
import { BorrowerDetailsPopUpComponent } from './loan-table/borrower-details-pop-up/borrower-details-pop-up.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule } from '@angular/forms';
import { FinzyFlexDirectiveModule } from '../../../../../directives/finzy-flex/finzy-flex-directive.module';
import { ProductResolver } from '../../../../../resolvers/product.resolver';
import { PipesModule } from '../../../../../utils/pipes/pipes.module';
import { LoanService } from '../../../../../service/finzy-flex/loan/loan.service';
import { BorrowerService } from '../../../../../service/finzy-flex/borrower/borrower.service';
import { CommonSectionsModule } from '../../../../common/common-sections.module';
import { AccountService } from '../../../../../service/finzy-flex/account/account.service';
import { SharedModule } from '../../../../../shared/shared.module';
import { FlexLoanSettlementComponent } from './flex-loan-settlement/flex-loan-settlement.component';

@NgModule({
    declarations: [
        FlexLoansComponent, 
        LoanTableComponent,
        InvestmentReversalPopUpComponent,
        BorrowerDetailsPopUpComponent,
        FlexLoanSettlementComponent
    ],
    imports: [
        FlexLoansRoutingModule,
        CommonSectionsModule,
        FormsModule,
        MatIconModule,
        MatPaginatorModule,
        MatSelectModule,
        MatChipsModule,
        MatDatepickerModule,
        FinzyFlexDirectiveModule,
        MatExpansionModule,
        MatProgressSpinnerModule,
        PipesModule,
        MatDialogModule,
        MatButtonModule,
        SharedModule
    ],
    providers: [ProductResolver, LoanService, BorrowerService, AccountService]
})
export class FlexLoansModule { }